import { Skeleton, Stack } from '@mui/material'
import React from 'react'

const CustomLoadingDetail = () => {
  return (
    <Stack spacing={2}>
        <Skeleton variant="text" width={150} sx={{ fontSize: '1rem' }} />
        <Skeleton variant="rectangular"  height={100} />
        <Skeleton variant="text"  width={150} sx={{ fontSize: '1rem' }} />
        <Skeleton variant="rectangular"  height={50} />
        <Skeleton variant="text"  width={150}  sx={{ fontSize: '1rem' }} />
        <Skeleton variant="rectangular"  height={100} />
    </Stack>
  )
}

export default CustomLoadingDetail